import { render, staticRenderFns } from "./AppSidemenu.vue?vue&type=template&id=3975e27b&scoped=true"
import script from "./AppSidemenu.vue?vue&type=script&lang=js"
export * from "./AppSidemenu.vue?vue&type=script&lang=js"
import style0 from "./AppSidemenu.vue?vue&type=style&index=0&id=3975e27b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3975e27b",
  null
  
)

export default component.exports